export class BOCompany {
    id:number;
    name:string;
    nit:string;
    email:string;
    logo:string;
}